<template>
  <mds-thead class="custom-table__head">
    <mds-th
      v-for="(column, key) in columns"
      :key="key"
      class="custom-table__header"
    >
      {{ translate(column) }}
    </mds-th>
    <mds-th class="custom-table__header custom-table__header--action"></mds-th>
  </mds-thead>
</template>

<script>
import { MdsThead, MdsTh } from '@mds/data-table'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/config/i18n'
export default {
  name: 'CustomTableHeader',
  components: {
    MdsThead,
    MdsTh,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@mds/constants';

.custom-table {
  &__header {
    padding-left: $mds-space-1-x;

    &:first-child {
      width: 260px;
    }
    &--action {
      width: 200px;
    }
  }
}
</style>
